
import { defineComponent } from "vue";

export default defineComponent({
  name: "Menu",
  props: {
    hasFocus: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasHover: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    className() {
      let className = "menu";
      if (this.hasHover) className += " hover";
      if (this.hasFocus) className += " focus";
      return className;
    },
  },
});
